import { render } from "./FormComponent.vue?vue&type=template&id=1aa62b46&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=1aa62b46&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa62b46"]])

export default __exports__